import { supabase } from '../client'
import type { AuctionInsert } from '../../types'

export async function addAuction(auctionInsert: AuctionInsert) {
  const { data, error } = await supabase.from('auctions').insert(auctionInsert).select().single()
  return { data, error }
}
